import { render, staticRenderFns } from "./VideoCallRoomMultiple.vue?vue&type=template&id=38b2204a&scoped=true&"
import script from "./VideoCallRoomMultiple.vue?vue&type=script&lang=js&"
export * from "./VideoCallRoomMultiple.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallRoomMultiple.vue?vue&type=style&index=0&id=38b2204a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2204a",
  null
  
)

export default component.exports